import { render } from "./WorkforceRequest.vue?vue&type=template&id=183143a7&scoped=true&ts=true"
import script from "./WorkforceRequest.vue?vue&type=script&lang=ts"
export * from "./WorkforceRequest.vue?vue&type=script&lang=ts"

import "./WorkforceRequest.vue?vue&type=style&index=0&id=183143a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183143a7"]])

export default __exports__